import { z } from 'zod';

const SnsAccountServiceSchema = z.object({
  snsType: z.enum(['ETC', 'INSTAGRAM', 'YOUTUBE', 'TWITTER', 'TIKTOK']).nullable(),
  url: z.string(),
});

export const SubmitJoinApplicationServiceRequestSchema = z.object({
  snsAccounts: z.array(SnsAccountServiceSchema).min(1).max(2),
  shopTitle: z
    .string()
    .regex(/^[a-zA-Z0-9]+$/, '큐레이터샵 타이틀은 영문과 숫자만 사용 가능합니다'),
  agreedTerms: z.array(
    z.enum([
      'SERVICE_TERMS',
      'SERVICE_POLICY',
      'SERVICE_TERMS_V1',
      'SERVICE_TERMS_V2',
      'SERVICE_POLICY_V1',
      'PRIVACY_COLLECTION_V1',
    ]),
  ),
});

export const SubmitJoinApplicationServiceResponseSchema = z.object({
  curatorId: z.string(),
});

export type SubmitJoinApplicationServiceRequest = z.infer<
  typeof SubmitJoinApplicationServiceRequestSchema
>;

export type SubmitJoinApplicationServiceResponse = z.infer<
  typeof SubmitJoinApplicationServiceResponseSchema
>;
